import {
  Box,
  Button,
  Collapse,
  Flex,
  Rotate,
  SearchInput,
  FilterListOutlinedIcon,
  ExpandMoreRoundedIcon,
  type SearchInputProps,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useExamLocationListSearchParams } from '../../hooks';
import { ExamLocationFilterSection } from '../exam-location-filter-section';

export default function ExamLocationSearchFilter() {
  const [isExpand, { toggle: toggleExpand }] = useDisclosure(false);
  const [{ locationName }, { changeLocationName }] = useExamLocationListSearchParams();

  const handleSearchInputChange: SearchInputProps['onChange'] = (value) => {
    changeLocationName(value);
  };

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ width: 300 }}>
          <SearchInput
            defaultValue={locationName ?? undefined}
            placeholder='ค้นหาชื่อสถานที่/หน่วยงาน...'
            onChange={handleSearchInputChange}
          />
        </Box>
        <Button
          variant='outlined'
          color='secondary'
          size='large'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggleExpand}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <ExamLocationFilterSection />
      </Collapse>
    </>
  );
}
